
































































































import Vue from '@front-app/vendor/vue';
import {
	defineComponent,
	ref,
	PropType,
	computed,
	nextTick,
} from '@vue/composition-api';
import { DropdownPosition } from '@front-app/components/dropdowns/dropdownPosition';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { useTranslate } from '@front-app/hooks/useTranslate';
import { Size } from '@front-app/components/constants';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { FOCUSABLE_ERROR_INPUT_CLASS } from '@front-app/components/form/form';
import ChevronIcon from '@front-app/components/icons-old/ChevronDown.vue';
import SimpleDropdown from '@front-app/components/dropdowns/SimpleDropdown.vue';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import FormInput from '@front-app/components/form/FormInput.vue';
import { FontAwesomeIconProps } from '@front-app/vendor/icon-definitions';
import { SelectBoxChoice } from './SelectBoxModel';
import RadioListButton from './RadioListButton.vue';

let i = 0;
const uid = () => `radio_box_${i++}`;

export default defineComponent({
	components: {
		ChevronIcon,
		SimpleDropdown,
		CtaButton,
		FontAwesomeIcon,
		FormInput,
		RadioListButton,
	},
	props: {
		triggerButtonSize: {
			type: String as PropType<Size>,
			default: Size.MEDIUM,
		},
		choices: {
			type: Array as PropType<SelectBoxChoice[]>,
			required: true,
		},
		selectedChoice: {
			type: [String, Number],
			default: undefined,
		},
		position: {
			type: Number as PropType<DropdownPosition>,
			default: DropdownPosition.BOTTOM_RIGHT,
		},
		icons: {
			type: [Object, undefined] as PropType<Record<string | number, FontAwesomeIconProps>>,
			default: () => ({}),
		},
		activatorButtonId: {
			type: String,
			required: false,
			default: '',
		},
		fullWidth: Boolean,
		searchable: Boolean,
		hasIcons: Boolean,
		hasError: Boolean,
		translateLabels: Boolean,
	},
	setup(props, ctx) {
		const theUid = uid();
		const isMenuOpen = ref(false);
		// Filter
		const inputField = ref(null as null | Vue);
		const filterText = ref('');
		const filteredChoices = computed(() => props.choices
			.filter(({ label }) => label.toLocaleLowerCase().includes(filterText.value.toLocaleLowerCase())));
		// END Filter
		const selectItem = (selection: SelectBoxChoice) => {
			ctx.emit('select', selection.key);
			isMenuOpen.value = false;
		};
		const selectedLabel = computed(() => {
			const current = props.choices.find(({ key }) => key === props.selectedChoice);
			return current?.label;
		});
		const selectedIcon = computed(() => {
			if (!props.hasIcons) {
				return '';
			}
			const theKey = props.choices.find(({ key }) => key === props.selectedChoice)?.key;
			if (!theKey) {
				return '';
			}
			return props.icons[theKey];
		});

		// Transform the "choices" into things that can be used
		// via a scoped slot
		const $t = useTranslate(ctx);
		const slotChoices = computed(() => filteredChoices.value.map((choice) => ({
			choice,
			label: props.translateLabels ? $t(choice.label) : choice.label,
			bind: {
				'data-key': choice.key,
				disabled: choice.disabled,
				checked: props.selectedChoice === choice.key,
				value: choice.key,
				icon: (props.hasIcons && props.icons[choice.key]) || false,
			},
			on: {
				click: () => selectItem(choice),
			},
		})));

		return {
			uid: theUid,
			inputField,
			filterText,
			filteredChoices,
			slotChoices,
			isMenuOpen,
			selectItem,
			selectedLabel,
			selectedIcon,
			FOCUSABLE_ERROR_INPUT_CLASS,
			ButtonPalettes,
			toggleMenu: async () => {
				isMenuOpen.value = !isMenuOpen.value;
				if (!isMenuOpen.value) {
					return;
				}
				await nextTick();
				await nextTick();
				const el = document.querySelector(`#${theUid} [data-key="${props.selectedChoice}"]`) as undefined | HTMLButtonElement;
				if (!el) {
					return;
				}
				el.focus();
				el.scrollIntoView({ block: 'center' });
			},
		};
	},
});
